export const GA4_ID = import.meta.env.VITE_GA4_ID || "G-XXXXXXXXXX";

export function gtag(...args: (string | Record<string, unknown>)[]) {
  if (typeof window !== "undefined" && (window as unknown as Record<string, unknown>).gtag) {
    ((window as unknown as Record<string, (...a: unknown[]) => void>).gtag as (...a: unknown[]) => void)(...args);
  }
}

export function pageView(url: string, title?: string) {
  gtag("event", "page_view", {
    page_location: url,
    page_title: title || document.title,
    send_to: GA4_ID,
  });
}

export function trackEvent(
  eventName: string,
  params?: Record<string, unknown>
) {
  gtag("event", eventName, {
    ...params,
    send_to: GA4_ID,
  });
}